module.exports = __webpack_public_path__ + "static/media/Avatars_Other-25.d86089b3.png";